import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 bg-white" data-id="element-89">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-90">
        <div className="w-16 h-16 bg-stone-100 rounded-2xl flex items-center justify-center mx-auto mb-8 transform -rotate-6" data-id="element-91">
          <MessageCircleIcon className="w-8 h-8 text-stone-600" data-id="element-92" />
        </div>

        <p className="text-2xl md:text-3xl font-serif text-stone-800 leading-relaxed mb-10" data-id="element-93">
          Estás en la cocina, el fregadero está lleno y hay juguetes por todo el
          suelo. De repente, recibes ese mensaje:
        </p>

        <div className="bg-stone-50 border border-stone-200 rounded-2xl p-6 md:p-8 max-w-xl mx-auto shadow-sm mb-10 relative" data-id="element-94">
          <div className="absolute -left-3 top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-[12px] border-t-transparent border-r-[12px] border-r-stone-200 border-b-[12px] border-b-transparent" data-id="element-95"></div>
          <div className="absolute -left-[10px] top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-stone-50 border-b-[10px] border-b-transparent" data-id="element-96"></div>
          <p className="text-xl md:text-2xl font-medium text-stone-900 italic" data-id="element-97">
            "Estamos cerca, ¿pasamos en 10 minutos?"
          </p>
        </div>

        <div className="space-y-4 text-lg text-stone-600 text-left max-w-2xl mx-auto" data-id="element-98">
          <p data-id="element-99">Ese nudo en el estómago no es por la visita.</p>
          <p className="font-medium text-stone-800" data-id="element-100">
            Es la punzada de vergüenza.
          </p>
          <p data-id="element-101">Es el miedo a ser juzgado.</p>
          <p data-id="element-102">
            Es la ganas de apagar las luces y fingir que no hay nadie en casa.
          </p>
        </div>
      </div>
    </section>;
}